const DATA_TEST_IDS = {
  sharedNpiFormView: 'profile__npi-search-forms_shared_npi-form-view',
} as const;

export default DATA_TEST_IDS;
